import React from 'react'
import BaseIcon from 'react-icon-base'

const GH = props => (
  <BaseIcon width={21} height={15} viewBox="0 0 450 300" {...props}>
    <title>Flag of Ghana</title>
    <rect width="450" height="300" fill="#006b3f" />
    <rect width="450" height="200" fill="#fcd116" />
    <rect width="450" height="100" fill="#ce1126" />
    <path d="M225,100 257.492,200 172.427,138.197H277.573L192.508,200z" fill="#000" />
  </BaseIcon>
)

export default GH
